import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import Settings from './Settings'
import Auth from './Auth'
import System from './System'
import Components from 'reducers/Components'

const reducers = combineReducers({
  routing: routerReducer,
  settings: Settings,
  auth: Auth,
  system: System,
  components: Components
})

export default reducers



// WEBPACK FOOTER //
// ./reducers/index.js